var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "94.000000pt",
    height: "94.000000pt",
    viewBox: "0 0 94.000000 94.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,94.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612 728 l-243 -91 25 -26 c59 -61 77 -178 52 -331 -8 -52 -22 -117 -30 -145 -9 -27 -14 -50 -12 -52 1 -1 13 16 26 40 95 172 304 534 312 542 7 7 9 3 5 -14 -3 -13 -2 -20 2 -15 21 23 120 184 113 184 -4 0 -116 -42 -250 -92z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e4fc270f.svg";
export { ForwardRef as ReactComponent };